module.exports = __webpack_public_path__ + "static/img/3dgif.f9bd749b.gif";